// extracted by mini-css-extract-plugin
export default {"container":"Badge_container__F60de","badge":"Badge_badge__DpYVZ","success":"Badge_success__uybTj","inProgress":"Badge_inProgress__8tFsv","error":"Badge_error__zUScf"};